// Renders a plain-text post body as readable paragraphs (blank line = new
// paragraph, single newline = line break). Text is rendered as React nodes, so
// it's XSS-safe. Rich text + media is a later milestone.

export function Prose({ text }: { text: string }) {
  const paragraphs = text.split(/\n{2,}/).map((p) => p.trim()).filter(Boolean);

  if (paragraphs.length === 0) {
    return <p className="italic text-ink-muted">No words on this one — just the moment.</p>;
  }

  return (
    <div className="flex flex-col gap-4 text-[1.05rem] leading-relaxed text-ink-soft">
      {paragraphs.map((para, i) => (
        <p key={i}>
          {para.split("\n").map((line, j, lines) => (
            <span key={j}>
              {line}
              {j < lines.length - 1 ? <br /> : null}
            </span>
          ))}
        </p>
      ))}
    </div>
  );
}
